import { render, staticRenderFns } from "./ProductCategoriesCombo.vue?vue&type=template&id=7d9c535a&scoped=true"
import script from "./ProductCategoriesCombo.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9c535a",
  null
  
)

export default component.exports